import { SovosButton, SovosDialog, SovosDialogActions, SovosDialogContent, SovosDialogTitle } from 'mosaic-react';

interface UpdateGlobalTemplateDialogProps {
	isDialogOpen: boolean;
	onClose: () => void;
	onValueGlobalTemplateEditClick: () => void;
}

const UpdateGlobalTemplateDialog = (props: UpdateGlobalTemplateDialogProps) => {
	const { isDialogOpen, onClose, onValueGlobalTemplateEditClick } = props;

	return (
		<SovosDialog open={isDialogOpen} onClose={() => onClose()}>
			<SovosDialogTitle className='custom-title'>Edit this global template?</SovosDialogTitle>
			<SovosDialogContent>
				<p style={{ color: '#FF0000', fontWeight: 'bold' }}> {'WARNING!'} </p>
				<p>
					{`Editing the global template will overwrite the default template settings. 
          This action will impact all Batch users, 
          across all organizations, and should only be made in consultation with the Batch Product Team.`}
				</p>
				<p>{'Are you sure you want to continue?'}</p>
			</SovosDialogContent>
			<SovosDialogActions>
				<SovosButton variant='text' onClick={() => onClose()}>
					Cancel
				</SovosButton>
				<SovosButton onClick={() => onValueGlobalTemplateEditClick()}>Yes, edit template</SovosButton>
			</SovosDialogActions>
		</SovosDialog>
	);
};

export default UpdateGlobalTemplateDialog;
